import { useNavigate } from 'react-router-dom';
import React from "react";
import { RoutineAndActivity } from "us.collection.routines-and-activities/components";

interface ICnt_Sentences {
  caseNo: number;
}

const Cnt_Sentences: React.FC<ICnt_Sentences> = (props) => {
  const navigate = useNavigate();

  const onMinimize = (url: string) => {
    navigate(url);
  };

  return (
    <RoutineAndActivity onMinimize={onMinimize} {...props}></RoutineAndActivity>
  );
};

export default Cnt_Sentences;
